import { useGetRenewVisaDocumentGroupInfo } from "@/api/services/main/renew-visa";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { Tab } from "@/components/elements/Tab";
import { TopPage } from "@/components/elements/TopPage";
import { RenewVisaProgressStep } from "@/features/renew-visa/components/present/RenewVisaProgressStep";
import { useCheckRenewVisaHistoryPage } from "@/features/renew-visa/hook/useCheckRenewVisaHistoryPage";
import { useInitSetup } from "@/providers/InitSetupProvider";
import { AppRoutes } from "@/routes/config";
import { background, divider } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { getFullName, truncateWithEllipsis } from "@/utils/string";
import { getDynamicRoute } from "@/utils/url";
import { Box } from "@mui/material";
import { FC, useMemo } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

type TRenewVisaLayoutProps = {};

export const RenewVisaLayout: FC<TRenewVisaLayoutProps> = () => {
  const navigate = useNavigate();

  const { employeeRenewVisaDocumentGroupId } = useParams();

  const { isLoading: isLoadingRenewVisaDocumentGroup, data: renewVisaDocumentGroup } = useGetRenewVisaDocumentGroupInfo();

  const { isHistoryPage } = useCheckRenewVisaHistoryPage();

  const { isLoading: isInitLoading } = useInitSetup();

  const title = useMemo(() => {
    if (!renewVisaDocumentGroup) return "";
    const firstEmployeeFullName = getFullName({
      lastName: renewVisaDocumentGroup?.employeeRenewVisaDocuments.at(0)?.employee?.lastName,
      firstName: renewVisaDocumentGroup?.employeeRenewVisaDocuments.at(0)?.employee?.firstName || "",
      middleName: renewVisaDocumentGroup?.employeeRenewVisaDocuments.at(0)?.employee?.middleName,
    });
    return `${renewVisaDocumentGroup?.company.companyName}│${truncateWithEllipsis(firstEmployeeFullName, 26)}さん${renewVisaDocumentGroup?.employeeRenewVisaDocuments.length - 1 > 0 ? `と他${renewVisaDocumentGroup?.employeeRenewVisaDocuments.length - 1}名` : ""}の在留期間更新`;
  }, [renewVisaDocumentGroup]);

  if (isLoadingRenewVisaDocumentGroup || isInitLoading) return <LoadingPage />;
  return (
    <Box>
      <TopPage
        title={title}
        description={isHistoryPage ? "本所属機関に関して過去に申請した在留期間更新申請の一覧です。" : undefined}
        backUrl={AppRoutes.renewVisa}
      />
      {!isHistoryPage && <RenewVisaProgressStep />}
      <Tab
        value={location.pathname}
        onChange={(_, tab) => navigate(tab.toString())}
        options={[
          { label: "今回", value: getDynamicRoute(AppRoutes.renewVisaPresent, { employeeRenewVisaDocumentGroupId }) },
          { label: "過去提出分", value: getDynamicRoute(AppRoutes.renewVisaInfoHistory, { employeeRenewVisaDocumentGroupId }) },
        ]}
      >
        <Box
          border={`1px solid ${divider.middle}`}
          bgcolor={background.white}
          sx={{ borderBottomLeftRadius: rounded.sm, borderBottomRightRadius: rounded.sm }}
        >
          <Outlet />
        </Box>
      </Tab>
    </Box>
  );
};
